import router from '../router'

const getUser = () => {
  return
}

const getToken = () => {
  return
}


export default {
  state: {
    //user: {},
    user: JSON.parse(localStorage.getItem('user')) || {},
    //token: null,
    token: localStorage.getItem('token') || null
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload
    },
    setToken(state, payload) {
      state.token = payload
      axios.defaults.headers.common = {
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + payload
      }
    },
    logout(state) {
      localStorage.removeItem('user')
      localStorage.removeItem('token')

      state.user = {}
      state.token = null
    },
  },
  actions: {
    queryAuth({dispatch, commit}) {
      dispatch('setPreloader', true)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'account')
        .then(res => {
          dispatch('setPreloader', false)
          commit('setUser', res.data.user)
        })
    },
    register({commit, dispatch}, payload) {
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'register', payload)
        .then(res => {
          dispatch('setPreloader', false)
          if (res.status === 201) {
            dispatch('setToast', {status: 'success', message: res.data.message})
            router.push('/')
          } else {
            dispatch('setToast', {status: 'warning', message: 'Registration failed'})
          }
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response)
        })
    },
    registerMonitor({commit, dispatch}, payload) {
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'register/monitor', payload)
        .then(res => {
          dispatch('setPreloader', false)
          if (res.status === 201) {
            dispatch('setToast', {status: 'success', message: res.data.message})
            return true
          } else {
            dispatch('setToast', {status: 'warning', message: 'Registration failed'})
          }
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response)
        })
    },
    login({commit, dispatch}, payload) {
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'auth', payload)
        .then(res => {
          dispatch('setPreloader', false)
          if (res.status === 203) {
            dispatch('setToast', {status: 'warning', message: res.data.message})
            window.location = res.data.link
          } else {
            localStorage.setItem('user', JSON.stringify(res.data.user))
            localStorage.setItem('token', res.data.token)

            commit('setUser', res.data.user)
            commit('setToken', res.data.token)
            dispatch('setToast', {status: 'success', message: 'Authentication success'})
            router.push('/dashboard')
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            dispatch('setToast', {status: 'warning', message: 'Email or password is not correct'})
          } else if (error.response.status === 423) {
            dispatch('setToast', {status: 'warning', message: 'Account not activated'})
          } else {
            dispatch('setToastHttpError', error.response)
          }
          dispatch('setPreloader', false)
        })
    },
    deleteAccount({ commit, dispatch }, payload) {
      if (confirm("In the event you delete your account, you will lose all the survey information stored on this device. To submit more questionnaires, you will need to request a new account and activation from PAN UK. Are you sure to delete this?") == false) {
        return false;
      }
      console.log("111111111111111111111111111111111");
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'delete-account', payload)
        .then(res => {
          console.log("res999999999", res);
          dispatch('setPreloader', false)
          if (res.status === 203) {
            dispatch('setToast', { status: 'warning', message: res.data.message })
            window.location = res.data.link
          } else {
            // localStorage.setItem('user', JSON.stringify(res.data.user))
            // localStorage.setItem('token', res.data.token)

            // commit('setUser', res.data.user)
            // commit('setToken', res.data.token)
            dispatch('setToast', { status: 'success', message: 'Deleted Success' })
            router.push('/delete-account')
          }
        })
        .catch((error) => {
          console.log("error------------", error);
          if (error.response.status === 401) {
            dispatch('setToast', { status: 'warning', message: 'Email is not correct' })
          } else {
            dispatch('setToastHttpError', error.response)
          }
          dispatch('setPreloader', false)
        })
    },
    logout({commit, dispatch}) {
      dispatch('setPreloader', true)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'logout')
        .then(res => {
          commit('logout')
          dispatch('setToast', {status: 'success', message: res.data.message})
          dispatch('setPreloader', false)
          router.push('/')
        })
    },
    restorePassword({commit, dispatch}, payload) {
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'restore-password', payload)
        .then(res => {
          dispatch('setPreloader', false)
          dispatch('setToast', {status: 'success', message: res.data.message})
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response)
        })
    }
  },
  getters: {
    getAuthUser: state => {
      return state.user
    },
  }
}